import React from 'react';

export const InputPercentagelabeled = ({ children, className, ...rest }) => {
  return (
    <div className={className}>
      <div className="bullet-list"><div className="bullet"></div>{children}</div>
      <div className="input"><input type="number" placeholder="0" {...rest} required/><span className="text-04-sky-blue-bold">%</span></div>
    </div>
  )
}